import { render, staticRenderFns } from "./SpiritDetails.vue?vue&type=template&id=1e65df87"
import script from "./SpiritDetails.vue?vue&type=script&lang=js"
export * from "./SpiritDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e65df87')) {
      api.createRecord('1e65df87', component.options)
    } else {
      api.reload('1e65df87', component.options)
    }
    module.hot.accept("./SpiritDetails.vue?vue&type=template&id=1e65df87", function () {
      api.rerender('1e65df87', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/SpiritDetails.vue"
export default component.exports